// Pure math for translating a two-finger pinch into board zoom steps. The
// Godot export only zooms via the mouse wheel, so the touch layer converts
// pinch-distance changes into synthetic WheelEvents (one "step" per
// STEP_PX of finger travel). Kept free of DOM types for direct unit testing.

export interface TouchPoint {
  clientX: number
  clientY: number
}

// Distance between the two active fingers.
export function touchDistance(a: TouchPoint, b: TouchPoint): number {
  return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY)
}

// Midpoint between the fingers — where the synthetic wheel event lands, so
// engines that zoom toward the cursor zoom toward the pinch center.
export function touchMidpoint(a: TouchPoint, b: TouchPoint): { x: number, y: number } {
  return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 }
}

export const PINCH_STEP_PX = 14

// How many wheel steps a distance change is worth, plus the leftover to
// carry into the next move event (so slow pinches still accumulate).
// Positive steps = fingers spreading = zoom in (negative wheel deltaY).
export function pinchWheelSteps(
  lastDistance: number,
  newDistance: number,
  stepPx: number = PINCH_STEP_PX,
): { steps: number, carry: number } {
  const delta = newDistance - lastDistance
  const steps = Math.trunc(delta / stepPx)
  return { steps, carry: delta - steps * stepPx }
}
